import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Chip from 'Chip';
import errorBoundary from '@ifeng/errorBoundary';
import Ad from '@ifeng/ui_pc_ad';
import styles from './index.css';
import Footer from '../../../../components/footer/';

const FooterPart = errorBoundary(
    class extends PureComponent {
        static propTypes = {
            content: PropTypes.object,
        };

        render() {
            const {
                content: { footer, ad_bottom_banner },
            } = this.props;

            return (
                <div>
                    <Ad content={ad_bottom_banner} styleName={styles.ad} />
                    <Chip id="20036" type="struct" title="全站通用页尾导航" groupName="底部" content={footer}>
                        <Footer />
                    </Chip>
                </div>
            );
        }
    },
);

export { FooterPart };
export default FooterPart;
